<template>
  <div class="d-inline-block">
    <div>
      <div class="mt-10">
        <div class="d-inline-flex align-center mb-0">
          <p class="mb-0 mt-1 tabTitleFontSize font-weight-bold">
            포인트 판매 서비스 - 쇼핑몰 디자인
          </p>
        </div>
        <v-card width="876" outlined class="mt-3">
          <div class="pa-0 ml-5 align-center mt-3 mb-3">
            <div v-if="use_html == 'enabled'">
              <div class="d-inline-flex align-center mb-0">
                <p class="mb-0 mt-1 cafe24HTMLPageCardText">
                  <font class="primary--text font-weight-bold">설정완료</font>
                  상태입니다.
                </p>
              </div>
              <div>
                <p class="mb-0 mt-3 subtitle-2 font-weight-medium">URL 주소 : {{ mall_url }}</p>
                <v-btn
                  depressed
                  small
                  color="#8292ff"
                  class="caption white--text mt-3"
                  aling="right"
                  right
                  style="background-color: rgb(127, 127, 127); border-color: rgb(127, 127, 127);"
                  v-clipboard:copy="mall_url"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  >URL 복사</v-btn
                >
                <p class="mb-0 mt-3 subtitle-2 font-weight-medium">
                  ㆍ쇼핑몰에 설치된 URL 링크를 연결하여 쇼핑몰 고객들에게 제공하세요.
                </p>
                <p class="mb-0 mt-1 subtitle-2 font-weight-medium">
                  ㆍ관련 문의사항이 있으시면 고객센터(0505-277-7770) 연락주시면 친절하게
                  안내드리겠습니다.
                </p>
              </div>
            </div>
            <div v-else>
              <div class="d-inline-flex align-center mb-0">
                <p class="mb-0 mt-1 cafe24HTMLPageCardText">
                  <font class="purple--text font-weight-bold">미설정</font>
                  상태입니다.
                </p>
              </div>
              <div>
                <p class="mb-0 mt-3 subtitle-2 font-weight-medium">
                  ㆍ포인트 판매 서비스를 위해 쇼핑몰에 HTML 적용이 필요합니다.
                </p>
                <p class="mb-0 mt-1 subtitle-2 font-weight-medium">
                  ㆍPC,모바일 쇼핑몰의 별도 서비스 페이지 생성 및 주문서 관련 수정이 필요합니다.
                </p>
                <p class="mb-0 mt-1 subtitle-2 font-weight-medium">
                  ㆍ아래의 무료신청 버튼을 클릭하여 신청을 주시거나, 고객센터 (0505-277-7770)
                  연락주시면 설치를 무료 지원해드립니다.
                </p>
                <p class="mb-0 mt-1 subtitle-2 font-weight-medium">
                  ㆍ평균 영업일 기준 1~2일 기준으로 설치가 완료되어 회신드리며, 이후 쇼핑몰에서
                  원활하게 사용하실 수 있습니다.
                </p>
              </div>
              <div>
                <div class="ml-1 my-2 mt-5">
                  <v-btn depressed large color="primary" @click="additionalServiceApply()"
                    >쇼핑몰 디자인 HTML - 무료 신청하기</v-btn
                  >
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import M from "@/libs/mapping.js";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

export default {
  data: () => ({
    M,
    use_html: null,
    mall_id: null,
    mall_url: null,
  }),
  methods: {
    additionalServiceApply: function() {
      window.open("https://forms.gle/moL9W2m2egZ9HMgG8", "_blank");
    },
    searchHtmlSetting: async function() {
      try {
        let result = await M.api(M.entry("/get/mileage/config/html"));
        if (result.use_html == "enabled") {
          this.use_html = result.use_html;
        }
      } catch (e) {
        //
      }
    },
    onCopy: function() {
      alert("복사 되었습니다.\n붙여넣기(ctrl+v)로 사용하세요.");
    },
    onError: function(e) {
      console.log(e.text);
    },
  },
  created: async function() {
    await this.searchHtmlSetting();
    this.mall_id = this.$store.state.mallId;
    this.mall_url = `http://${this.mall_id}.cafe24.com/point.html`;
  },
};
</script>
